<p-dialog
  [visible]="visible"
  (visibleChange)="visibleChange.emit($event)"
  (onHide)="resetForm()"
  (onShow)="onShow()"
  [blockScroll]="true"
  [modal]="true"
  [style]="{ width: '750px' }"
  header="Record Delay/Failure Customer Notification"
>
  <div class="ui-g" style="margin-left: 8px; margin-bottom: 30px">
    <div class="ui-g-12" style="margin-bottom: 10px; font-weight: 500">
      {{ task?.vehicleMake }} {{ task?.vehicleModel }} ({{ task?.vehicleRegistration }})
    </div>
    <div class="ui-g-12" style="height: 28px">
      <span style="margin-left: 2px; margin-right: -2px"
        ><i class="vme-material-icons pick-up-color">&#xe805;</i></span
      >
      {{ task?.pickUpAddress }}
    </div>
    <div class="ui-g-12" style="height: 28px">
      <span><i class="vme-material-icons drop-off-color">&#xe804;</i></span>
      {{ task?.dropOffAddress }}
    </div>
  </div>

  <div class="ui-g">
    <div class="ui-g-3">Delay/Failure Category:</div>
    <div class="ui-g-9">
      <p-dropdown
        [(ngModel)]="newDelayFailureCategory"
        filter="true"
        [options]="delayFailureCategories"
        [style]="{ width: '100%' }"
        appendTo="body"
        id="delayFailure"
        name="delayFailure"
        (onChange)="onDelayFailureCategoryChange()"
      ></p-dropdown>
    </div>
  </div>

  <div class="ui-g">
    <div class="ui-g-3">Recipient Address</div>
    <div class="ui-g-9">
      <p-autoComplete
        #autocomplete
        [(ngModel)]="selectedEmailAddresses"
        [multiple]="true"
        [dropdown]="true"
        [suggestions]="emailAddressSuggestions"
        class="email-address w-full"
        (completeMethod)="filterEmailAddress($event)"
        inputStyleClass="w-full"
        styleClass="w-full"
      ></p-autoComplete>
    </div>
  </div>

  <div style="display: flex; margin-top: 5px">
    <div style="margin-top: 2px">Notify Customer with Email:</div>
    <p-inputSwitch [(ngModel)]="shouldSendEmail"></p-inputSwitch>
  </div>

  <div class="ui-g" style="margin-top: 10px">
    <div class="ui-g-12">New Note:</div>
  </div>
  <div class="ui-g">
    <div class="ui-g-12">
      <textarea
        [(ngModel)]="newDelayFailure"
        autocapitalize="off"
        autocomplete="off"
        autocorrect="off"
        class="w-full event-note-area"
        pInputTextarea
        rows="7"
        spellcheck="false"
      ></textarea>
    </div>
  </div>
  <p-footer>
    <div class="button-box">
      <button
        (click)="saveDelayFailure()"
        [disabled]="!newDelayFailureCategory || selectedEmailAddresses.length == 0"
        class="btn-to-right"
        label="Record"
        pButton
        type="button"
      ></button>
      <button
        (click)="visibleChange.emit(false)"
        class="ui-button btn-to-right ui-button-tertiary"
        label="Cancel"
        pButton
        type="button"
      ></button>
    </div>
  </p-footer>
</p-dialog>
